module.exports = __webpack_public_path__ + "img/icon_uestion.ee4ecce5.svg";